__turbopack_context__.v({
  "contactButton": "page-module__h18ZfW__contactButton",
  "contactButtonWrapper": "page-module__h18ZfW__contactButtonWrapper",
  "heartIcon": "page-module__h18ZfW__heartIcon",
  "mediaContent": "page-module__h18ZfW__mediaContent",
  "mediaLikes": "page-module__h18ZfW__mediaLikes",
  "mediaPicture": "page-module__h18ZfW__mediaPicture",
  "mediasGrid": "page-module__h18ZfW__mediasGrid",
  "photographerHeader": "page-module__h18ZfW__photographerHeader",
  "photographerLocation": "page-module__h18ZfW__photographerLocation",
  "photographerName": "page-module__h18ZfW__photographerName",
  "photographerPortrait": "page-module__h18ZfW__photographerPortrait",
  "photographerPresentation": "page-module__h18ZfW__photographerPresentation",
  "photographerTagline": "page-module__h18ZfW__photographerTagline",
  "portraitWrapper": "page-module__h18ZfW__portraitWrapper",
});
